import React, { Component } from "react";
import moment from "moment";
import { Col, Row } from "antd";
import titleize from "underscore.string/titleize";

export class ItemCarousel extends Component {
  render() {
    const { items, redirect } = this.props;
    const colors = {
      active: "#64b10a",
      created: "#64b10a"
    };

    if (items && items.length) {
      return (
        <div className="slider">
          <div className="slider-inner">
            {items.map((item, i) => {
              return (
                <div
                  className="slide-single"
                  style={{ marginLeft: i === 0 ? 0 : "50px" }}
                  onClick={() => redirect(`/challenges/${item.id}`)}
                >
                  <Row
                    className="slide-header"
                    align="middle"
                    type="flex"
                    justify="space-between"
                  >
                    <Col style={{ color: colors[item.status] }}>
                      {titleize(item.status)}
                    </Col>
                    <Col>
                      <span className="bold">
                        {moment(item.created_at).format("M/D/YYYY")}
                      </span>
                    </Col>
                  </Row>
                  <Row
                    className="slide-body"
                    type="flex"
                    align="middle"
                    justify="center"
                  >
                    <Col>
                      <Row className="bold" type="flex" justify="center">
                        {titleize(item.company_name)}
                      </Row>
                      <Row type="flex" justify="center">
                        {item.owner_name}
                      </Row>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    return (
      <div className="slider-no-results">
        <span className="bold">No new challenges submitted.</span>
      </div>
    );
  }
}

export default ItemCarousel;



// WEBPACK FOOTER //
// ./src/components/dashboard/challenge/carousel.js